import {} from 'scripts/main';

jQuery(($) => {
  // $('.ga-refferal-form').submit(function() {
  //   let action_label, mealProgram;
  //   mealProgram = $('.ga-refferal-form input[name="referral[program_type]"]:checked').val();
  //   action_label = (function() {
  //     switch (mealProgram) {
  //       case mealProgram = 'OneOff':
  //         return 'one_off_event_click';
  //         break;
  //       case mealProgram = 'MealProgram':
  //         return 'meal_program_click';
  //         break;
  //       default:
  //         return 'feed_us_noselection_click';
  //     }
  //   })();
  //   return ga('send', 'event', 'button', 'click', action_label, 1);
  // });
});
